import { render, staticRenderFns } from "./BaseToggle.vue?vue&type=template&id=df47a27c&"
import script from "./BaseToggle.vue?vue&type=script&lang=js&"
export * from "./BaseToggle.vue?vue&type=script&lang=js&"
import style0 from "./BaseToggle.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default})
